import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { pricePostingUsaProConstants } from "@/js/lists.ts";
export default {
  name: "MultipleCountryStatesSelector",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    countries: {
      type: Array,
      default: []
    },
    isHorecaIncludedInUserGroup: {
      type: Boolean,
      default: false
    },
    containsForbiddenStates: {
      type: Boolean,
      default: false
    },
    titleAll: {
      type: String,
      default: "All locations"
    }
  },
  components: {},
  data: function data(_this) {
    return {
      form: {
        locations: []
      },
      rules: formRules,
      pricePostingUsaProConstants: pricePostingUsaProConstants
    };
  },
  methods: {
    addLocation: function addLocation() {
      this.form.locations = [].concat(_toConsumableArray(this.form.locations), [{
        countryId: null,
        stateIds: []
      }]);
      this.valueChanged();
    },
    removeLocation: function removeLocation(index) {
      this.form.locations.splice(index, 1);
      this.valueChanged();
    },
    changeCountry: function changeCountry(location) {
      location.stateIds = [];
      this.valueChanged();
    },
    valueChanged: function valueChanged() {
      this.$emit("valueChanged", this.form.locations);
    },
    removeStateFromArrivals: function removeStateFromArrivals(index) {
      if (index > -1) {
        this.form.locations.forEach(function (x) {
          x.stateIds.splice(index, 1);
        });
      }
      this.valueChanged();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};